export default __webpack_public_path__ + "0f05458ca26ac9798472a95f7ab6414f.png";